/**
 * Mock 데이터 API 모듈
 * 로컬 JSON 파일에서 정적 콘텐츠 목록을 가져오는 함수들입니다.
 * 주로 소개 페이지와 돌봄서비스 페이지의 정적 콘텐츠에 사용됩니다.
 */

import List from "./mock.json";

/**
 * 목록 데이터를 가져오는 함수
 * ID에 따라 List1~List8 중 하나를 반환합니다.
 * "센터소개"(1~4) 및 "돌봄서비스"(1~6) 관련 메뉴에서 사용됩니다.
 *
 * @param {number|string} id - 목록 ID (1~8)
 * @returns {Object} mock.json에서 가져온 목록 데이터
 *
 * @example
 * const list = getList(1); // List1 반환
 * const list = getList(5); // List5 반환 (사회주택)
 */
export function getList(id) {
  // ID가 없으면 기본값으로 List1 반환
  if (!id) return List["List1"];

  // ID를 숫자로 변환하여 해당하는 목록 반환
  const numId = Number(id);
  if (numId >= 1 && numId <= 8) {
    return List[`List${numId}`];
  }

  // 범위 밖의 ID는 기본값 반환
  return List["List1"];
}

/**
 * 두 번째 카테고리의 목록 데이터를 가져오는 함수
 * ID에 따라 List5~List8 중 하나를 반환합니다.
 * 주로 "돌봄서비스" 관련 메뉴에서 사용됩니다.
 *
 * @param {number|string} id - 목록 ID (1~4)
 * @returns {Object} mock.json에서 가져온 목록 데이터
 *
 * @example
 * const list = getList2(1); // List5 반환 (돌봄서비스 첫 번째 메뉴)
 * const list = getList2(2); // List6 반환 (돌봄서비스 두 번째 메뉴)
 */
export function getList2(id) {
  // ID가 없으면 기본값으로 List5 반환
  if (!id) return List["List5"];

  // ID를 숫자로 변환하여 해당하는 목록 반환
  if (Number(id) === 1) return List["List5"];
  else if (Number(id) === 2) return List["List6"];
  else if (Number(id) === 3) return List["List7"];
  else if (Number(id) === 4) return List["List8"];
  else return List["List5"]; // 범위 밖의 ID는 기본값 반환
}
